/* eslint-disable */
export default {
  participants: '参加者',
  host: '(ホスト)',
  removeParticipant: '参加者を削除',
  removeTitle: '参加者を削除',
  removeDescription: 'この会議から{name}を削除しますか？',
  confirmButtonText: '削除',
  cancelButtonText: 'キャンセル',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
